import restProvider from 'ra-data-simple-rest'
import { fetchUtils } from 'react-admin'
import { auth0 } from '../auth/client'
import fakeDataProvider from './fakeDataProvider'

const httpClient = async (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' })
  }
  options.headers.set('Authorization', `Bearer ${await auth0.getTokenSilently()}`)
  return fetchUtils.fetchJson(url, options)
}

export default process.env.REACT_APP_BACKEND_URL
  ? restProvider(process.env.REACT_APP_BACKEND_URL, httpClient)
  : fakeDataProvider
